/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M7 (7.1).
 * Account-wide read of inbox→assistant bindings (/api/v1/accounts/:account_id/eva/inbox_bindings).
 * Backs the inbox-side Eva picker so it can show the current binding for an inbox.
 */
import ApiClient from 'dashboard/api/ApiClient';

class EvaInboxBindingsAPI extends ApiClient {
  constructor() {
    super('eva/inbox_bindings', { accountScoped: true });
  }
}

export default new EvaInboxBindingsAPI();
